import {Component, OnInit} from '@angular/core';
// tslint:disable-next-line:import-blacklist
import {Subject} from 'rxjs';
import {CatalogService} from '../catalogue/catalog-api/catalog.service';
import {ToasterService} from 'angular2-toaster';

const DEBOUNCE_TIME = 10;
const ES_RESULTS_SIZE = 20;
const ES_LARGER_SEARCH_AMOUNT = 100;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'business-operations-search-titles',
    templateUrl: 'business-operations-search-titles.component.html',
    styleUrls: ['business-operations-search-titles.component.scss']
})
export class BusinessOperationsSearchTitlesComponent implements OnInit {
    // Navigation
    navIndex = 0;
    private shouldDoSearch = false;
    // Subject for search debounce and search value
    private subject = new Subject<string>();
    searchValue = '';

    // Page booleans
    searchLoading = false;

    // ES Results
    results = [];
    private finalsResults = [];

    // Selected show for catalog-manage component
    selectedShow;
    // Number of hits for the ES search and details for loading more
    totalResultsMetadata = 0;
    totalResultsImdb = 0;
    private from = 0;
    private largerSearch = false;
    hasMore = false;

    constructor(private catalogService: CatalogService,
                private toasterService: ToasterService) {
    }

    ngOnInit() {
        this.subject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged((prev, curr) => prev === curr && !this.shouldDoSearch)
            .subscribe(searchValue => {
                // Search value has changed, reset results, total results and from
                this.results = [];
                this.finalsResults = [];
                this.totalResultsImdb = 0;
                this.totalResultsMetadata = 0;
                this.from = 0;
                this.doSearch(searchValue);
            });
    }

    onEnter(searchValue) {
        this.results = [];
        this.finalsResults = [];
        this.totalResultsImdb = 0;
        this.totalResultsMetadata = 0;
        this.from = 0;

        this.shouldDoSearch = false;
        this.searchLoading = true;
        this.searchValue = searchValue;


        this.catalogService.createBusinessSolutionAPI(
            searchValue
        ).then((res) => {

            this.results = this.results.concat(res.metadata.hits.hits.map(this.catalogService.mapBusinessOperationsResultItem));

            this.totalResultsMetadata = res.metadata.hits.total.value;
            this.hasMore = false;
            this.searchLoading = false;

            if (!this.results || this.results.length === 0) {
                this.toasterService.pop('info', 'No Relevant Answers Found');
            }

        }).catch((err) => {
            console.error('Failed to call the ES proxy in the catalog API' + err.toString());
            this.toasterService.pop('error', 'Failed to get any es response');
            this.searchLoading = false;
        });
    }


    doSearch(searchValue) {

        this.shouldDoSearch = false;
        this.searchLoading = true;
        this.searchValue = searchValue;

        const queryJSON = this.catalogService.createBusinessOperationsEsQuery(searchValue);

            this.catalogService.callBusinessOperationsEsProxyCustomQuery(
                queryJSON,
                'platform360-business-applications'
            ).then((res) => {

                this.results = this.results.concat(res.hits.hits.map(this.catalogService.mapBusinessOperationsResultItem));

                this.totalResultsMetadata = res.hits.total.value;
                const pageSize = this.largerSearch ? ES_LARGER_SEARCH_AMOUNT : ES_RESULTS_SIZE;
                this.hasMore = this.totalResultsMetadata > (this.from + pageSize);
                this.searchLoading = false;
            }).catch((err) => {
                console.error('Failed to call the ES proxy in the catalog API' + err.toString());
                this.toasterService.pop('error', 'Failed to call the ES proxy in the catalog API');
                this.searchLoading = false;
            });
    }

    handleLoadMore() {
        if (this.largerSearch) {
            this.from = this.from + ES_LARGER_SEARCH_AMOUNT;
        } else {
            this.from = this.from + ES_RESULTS_SIZE;
        }
        this.doSearch(this.searchValue);
    }

    handleNavSelect(index) {
        this.navIndex = index;
    }

    handleOpen(result) {
        if (!this.selectedShow || (this.selectedShow && this.selectedShow.id !== result.id)) {
            this.selectedShow = {
                business_question: result.business_question,
                industry_segment: result.industry_segment,
                chart_names: result.chart_names,
                id: result.id,
            };
        } else if (this.selectedShow && this.selectedShow.id === result.id) {
            // Trigger a change for the property
            setTimeout(() => {
                this.selectedShow = {
                    business_question: undefined,
                    industry_segment: undefined,
                    chart_names: undefined,
                    id: undefined

                };
            });
            setTimeout(() => {
                this.selectedShow = {
                    business_question: result.business_question,
                    industry_segment: result.industry_segment,
                    chart_names: result.chart_names,
                    id: result.id,
                };
            });
        }
    }

    onKeyUp(searchValue) {
        this.searchValue = searchValue;
        if (this.shouldSearch()) {
            this.subject.next(searchValue);
        } else {
            this.results = [];
        }
    }
    shouldSearch() {
        return this.searchValue;
    }
}



// WEBPACK FOOTER //
// ./src/app/business-operations/business-operations-search-titles.component.ts